import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import Selector from "../../../../../../atoms/ActiveLearning/Selector";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import CommentList from "../../../../../../molecules/ActiveLearning/CommentList";
import styles from "../../../ActiveLearningIssue.module.scss";
import hintImage13 from "../../../../../../assets/images/ActiveLearning/hint/img_13.webp";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          これまで考えてきた「問い」/「課題」/解決のアイデアを相手に伝わりやすくまとめて発表しよう。
          <br />
          発表を聞き終わったら、発表した人に良かった点を伝えたり、アドバイスしたりしよう。
        </p>
      </div>
      <img src={hintImage13} alt="発表を聞くときに良かった点を探すヒント" />
      {question1 && (
        <>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question1?.title}</p>
            <p className={styles.read}>
              発表を聞いて良かった点やアドバイスを具体的に入力して、発表者に送信しよう。
            </p>
          </div>
          <div className={styles.tree}>
            <Selector />
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>コメント</span>
                </div>
                <div className={styles.inputField}>
                  <TextArea />
                </div>
              </li>
            </ul>
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                送信する
              </Button>
            </div>
          </div>
          <div className={styles.commentList}>
            <div className={styles.label}>
              <p className={styles.title}>送ったコメント</p>
            </div>
            <CommentList commentList={[]} />
          </div>
        </>
      )}
    </div>
  );
};
export default Issue2Material;
